import markdownToHtml from "./markdown-viewer";

export default angular.module("vesl.components.markdown-to-html.index", [markdownToHtml]).name;
